import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "langs-container" }
const _hoisted_2 = ["onMouseenter"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "langs" }
const _hoisted_5 = { class: "lang" }
const _hoisted_6 = { class: "lang-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, ([lang, value], index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "lang-bar",
          style: _normalizeStyle({
          width: _ctx.getWidth(value),
          backgroundColor: _ctx.colors[lang],
        }),
          onMouseenter: ($event: any) => {;(_ctx.hoverIndex = index), (_ctx.displaycloud = true)},
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displaycloud = false))
        }, null, 44, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["cloud", { hidden: !_ctx.displaycloud }]),
      style: _normalizeStyle({
        left: _ctx.getCloudPos(_ctx.hoverIndex),
        backgroundColor: _ctx.colors[_ctx.langs[_ctx.hoverIndex][0]],
      }),
      innerHTML: ((100 * _ctx.langs[_ctx.hoverIndex][1]) / _ctx.total).toFixed(1) + '%'
    }, null, 14, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, ([lang], index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "dot",
              style: _normalizeStyle({ color: _ctx.colors[lang] })
            }, [
              _createVNode(_component_ic, { icon: "heart" })
            ], 4),
            _createElementVNode("span", _hoisted_6, _toDisplayString(lang), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}